import * as ko from "knockout";

// Models
import AlertBase, { IAlert } from 'Content/ts/Shared/BootstrapAlerts/AlertBase';

export default class AlertDanger extends AlertBase {
    constructor(params: IAlert) {
        super(params);
    }
}

const componentName = "alert-danger";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: AlertDanger,
    template: { require: `text!/Themes/Default/Content/ts/Shared/BootstrapAlerts/AlertDanger/${componentName}.html` }
});